import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import Essentials from '@client/react/components/Essentials'

let essentialsRoot = null
let essentialsContainer = null

const cleanupEssentialsModal = () => {
  if (essentialsRoot) {
    essentialsRoot.unmount()
    essentialsRoot = null
  }
  if (essentialsContainer && essentialsContainer.parentNode) {
    essentialsContainer.parentNode.removeChild(essentialsContainer)
    essentialsContainer = null
  }
}

export const showEssentialsModal = (productId, productName) => {
  // Clean up any existing modal first
  cleanupEssentialsModal()

  // Create fresh container
  essentialsContainer = document.createElement('div')
  essentialsContainer.id = 'tweakwise-essentials-modal'
  document.body.appendChild(essentialsContainer)

  // Create fresh root
  essentialsRoot = createRoot(essentialsContainer)

  const EssentialsWrapper = () => {
    const [initialize, setInitialize] = React.useState(true)

    return (
      <Provider store={window.reduxStore}>
        <Essentials
          id={productId}
          name={productName}
          initialize={initialize}
          setInitialize={setInitialize}
        />
      </Provider>
    )
  }

  essentialsRoot.render(<EssentialsWrapper />)
}

// Clean up on Turbolinks navigation
if (typeof document !== 'undefined') {
  document.addEventListener('turbolinks:before-render', cleanupEssentialsModal)
  document.addEventListener('turbolinks:before-cache', cleanupEssentialsModal)
}
